var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main_text"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"detail o"},[_vm._v(_vm._s(_vm.detail))])])}
var staticRenderFns = []

export { render, staticRenderFns }